module.exports = __webpack_public_path__ + "img/2.37dbd9a2.png";